const mapElement = document.getElementById('agsoz-map');
if (mapElement) {
	let isPathActive = false;
	const tooltipElement = document.createElement('div');
	tooltipElement.className = 'agsoz-map-tooltip';
	document.body.appendChild(tooltipElement);

	/** @var {SVGPathElement[]} paths */
	const paths = [...mapElement.getElementsByTagName('path')];

	paths.forEach(path => {
		path.addEventListener('mouseenter', e => {
			isPathActive = true;
			path.classList.add('agsoz-map-path-active');
			mapElement.style.cursor = 'pointer';
			tooltipElement.innerText = path.getAttribute('aria-label');
		});

		path.addEventListener('mouseleave', e => {
			isPathActive = false;
			path.classList.remove('agsoz-map-path-active');
			mapElement.style.cursor = '';
		});

		path.addEventListener('click', e => {
			window.location.href = path.getAttribute('data-href');
		});
	});

	mapElement.addEventListener('mousemove', e => {
		if (isPathActive) {
			tooltipElement.style.display = 'block';
			tooltipElement.style.top = `${e.pageY}px`;
			tooltipElement.style.left = `${e.pageX}px`;
		} else {
			tooltipElement.style.display = 'none';
		}
	});

	mapElement.addEventListener('mouseleave', _ => {
		tooltipElement.style.display = 'none';
	});
}
